import { Card, Field, FileInput } from '@payaca/ambrosia';
import { getAcceptedFileTypes } from '@payaca/helpers/fileHelper';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { z } from 'zod/v4';

export const LINE_ITEM_THUMBNAIL_FORM_SCHEMA = z.object({
  thumbnail: z
    .object({
      id: z.string().optional(),
      file: z.instanceof(File).optional(),
      preview: z.string(),
    })
    .optional(),
});

export type TLineItemThumbnailFormState = z.infer<
  typeof LINE_ITEM_THUMBNAIL_FORM_SCHEMA
>;

type TProps = {
  onDelete?: () => void;
};

const ThumbnailField: FC<TProps> = (props) => {
  const { onDelete } = props;

  const formMethods = useFormContext<TLineItemThumbnailFormState>();

  return (
    <Card>
      <Card.Body>
        <Field.Legacy>
          <Field.Label>Image</Field.Label>

          <Controller
            name="thumbnail"
            control={formMethods.control}
            render={({ field: { onChange, value } }) => {
              return (
                <FileInput
                  label="Thumbnail"
                  url={value?.preview}
                  onDrop={(file) => {
                    onChange({
                      file,
                      preview: URL.createObjectURL(file),
                    });
                  }}
                  onDelete={onDelete}
                  dropzoneOptions={{
                    accept: getAcceptedFileTypes(['image']),
                  }}
                />
              );
            }}
          />
        </Field.Legacy>
      </Card.Body>
    </Card>
  );
};

export default ThumbnailField;
